import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { MatSelectModule } from '@angular/material/select';
import { Overlay } from '@angular/cdk/overlay';
import { MAT_AUTOCOMPLETE_SCROLL_STRATEGY, MatAutocompleteModule } from '@angular/material/autocomplete';
import { TsButtonModule } from 'tsui';
import { TsDialogComponent } from 'tsui/lib/ts-dialog/ts-dialog.component';
import { AddLinkToCustomObjectValueDialog } from './add-link-to-custom-object-value.component';
import { MatOptionModule } from '@angular/material/core';
import { DirectivesModule } from '@shared/directives/directives.module';
import { FormFieldsModule } from '@shared/components/form-fields/form-fields.module';
import { AlertBannerComponent } from '@shared/components/widgets/alert-banner/alert-banner.component';

@NgModule({
  declarations: [AddLinkToCustomObjectValueDialog],
  exports: [AddLinkToCustomObjectValueDialog],
  imports: [
    TsDialogComponent,
    MatFormFieldModule,
    MatAutocompleteModule,
    FormsModule,
    ReactiveFormsModule,
    MatOptionModule,
    MatInputModule,
    DirectivesModule,
    MatDividerModule,
    TsButtonModule,
    FormFieldsModule,
    MatSelectModule,
    AlertBannerComponent,
  ],
  providers: [
    {
      provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
      useFactory: (overlay: Overlay) => {
        return () => overlay.scrollStrategies.block();
      },
      deps: [Overlay],
    },
  ],
})
export class AddLinkToCustomObjectValueModule {}
